import React, { type FC } from "react";

import { Editor } from "~/components/code/editor";
import { IconMainMenuMonitors } from "~/components/icon";

import type { FullComponent } from "../../../../../main/common/openapi";
import {
	CloseDrawerButton,
	CopyToClipboardDrawerButton,
	DrawerComponentTitle,
	DrawerTitle,
	ExplorationDrawer,
} from "../../../../components/react/drawer/ExplorationDrawer";

export type YamlDisplayDrawerStateType = "configuration" | "status" | "monitor definition";

export interface YamlDisplayDrawerState {
	type: YamlDisplayDrawerStateType;
	title?: string;
	component?: FullComponent;
	yaml: string;
}

export interface YamlDisplayDrawerProps {
	when: undefined | YamlDisplayDrawerState;
}

export const YamlDisplayDrawer: FC<YamlDisplayDrawerProps> = ({ when }) => (
	<ExplorationDrawer
		data-testid="yaml-display-drawer"
		footer={({ type, yaml }) => (
			<>
				<CloseDrawerButton />
				<CopyToClipboardDrawerButton content={yaml} contentType={type} />
			</>
		)}
		headerTitle={({ title = "", type, component }) => {
			if (title) {
				return (
					<DrawerTitle
						icon={<IconMainMenuMonitors className="text-gray-800" height={20} width={20} />}
						title={title}
						typeOfData={type}
					/>
				);
			}
			return <DrawerComponentTitle component={component} displayTypeName typeOfData={type} />;
		}}
		when={when}
	>
		{({ yaml }) => <Editor height="100%" language="yaml" readOnly value={yaml} />}
	</ExplorationDrawer>
);
